<div class="item-wrapper" (click)="itemClicked($event)" [class.disabled]="disabled">
  <studio-popup-menu-optional-anchor [href]="href" [target]="target">
    <p class="bold-text">
      {{ text }}
    </p>
    <p *ngIf="description" class="description">{{ description }}</p>
  </studio-popup-menu-optional-anchor>
</div>
